import { DeleteOrgFunctionRequestSchema, DeleteOrgFunctionResponseSchema } from './delete-org-function.schema';
/**
 * Delete OrgFunction Endpoint Contract
 * Deletes a OrgFunction by ID
 */ export const deleteOrgFunctionContract = {
    method: 'DELETE',
    path: '/api/v2/org-function/:id',
    description: 'Delete a OrgFunction by ID',
    requestSchema: DeleteOrgFunctionRequestSchema,
    responseSchema: DeleteOrgFunctionResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            401: 'Unauthorized - user not authenticated',
            404: 'OrgFunction not found'
        }
    }
};

//# sourceMappingURL=delete-org-function.contract.js.map